import { render, staticRenderFns } from "./InspectionReview.vue?vue&type=template&id=538545bc&scoped=true"
import script from "./InspectionReview.vue?vue&type=script&lang=js"
export * from "./InspectionReview.vue?vue&type=script&lang=js"
import style0 from "./InspectionReview.vue?vue&type=style&index=0&id=538545bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538545bc",
  null
  
)

export default component.exports